/**
 * @generated SignedSource<<1f60930fd90704ab3356c07a899afe9e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeletePhotoInput = {
  clientMutationId?: string | null | undefined;
  rowId: any;
};
export type PhotoViewDeletePhotoMutation$variables = {
  input: DeletePhotoInput;
};
export type PhotoViewDeletePhotoMutation$data = {
  readonly deletePhoto: {
    readonly query: {
      readonly currentUser: {
        readonly profile: {
          readonly photos: {
            readonly totalCount: number;
          };
          readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatar_profile" | "ProfilePhotosView_profile" | "useVerificationPhotos_profile">;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type PhotoViewDeletePhotoMutation = {
  response: PhotoViewDeletePhotoMutation$data;
  variables: PhotoViewDeletePhotoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "PhotoConnection",
  "kind": "LinkedField",
  "name": "photos",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "StorageObject",
  "kind": "LinkedField",
  "name": "storageObject",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blurhash",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bucket",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "type": {
        "equalTo": "PROFILE"
      }
    }
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sequence",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__id",
      "storageKey": null
    }
  ]
},
v13 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PhotoViewDeletePhotoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DeletePhotoPayload",
        "kind": "LinkedField",
        "name": "deletePhoto",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ProfileAvatar_profile"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "ProfilePhotosView_profile"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "useVerificationPhotos_profile"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "PhotoViewDeletePhotoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DeletePhotoPayload",
        "kind": "LinkedField",
        "name": "deletePhoto",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Profile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Photo",
                        "kind": "LinkedField",
                        "name": "headshot",
                        "plural": false,
                        "selections": [
                          (v3/*:: as any*/),
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "name",
                        "storageKey": null
                      },
                      {
                        "alias": "profilePhotos",
                        "args": (v5/*:: as any*/),
                        "concreteType": "PhotoConnection",
                        "kind": "LinkedField",
                        "name": "photos",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PhotoEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v6/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Photo",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v7/*:: as any*/),
                                  (v8/*:: as any*/),
                                  (v9/*:: as any*/),
                                  (v3/*:: as any*/),
                                  (v4/*:: as any*/),
                                  (v10/*:: as any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v11/*:: as any*/),
                          (v12/*:: as any*/)
                        ],
                        "storageKey": "photos(filter:{\"type\":{\"equalTo\":\"PROFILE\"}},first:10)"
                      },
                      {
                        "alias": "profilePhotos",
                        "args": (v5/*:: as any*/),
                        "filters": [
                          "filter"
                        ],
                        "handle": "connection",
                        "key": "useProfilePhotos_profile_profilePhotos",
                        "kind": "LinkedHandle",
                        "name": "photos"
                      },
                      (v4/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v13/*:: as any*/),
                            "concreteType": "PhotoConnection",
                            "kind": "LinkedField",
                            "name": "verificationPhotos",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PhotoEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  (v6/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Photo",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "createdAt",
                                        "storageKey": null
                                      },
                                      (v7/*:: as any*/),
                                      (v8/*:: as any*/),
                                      (v9/*:: as any*/),
                                      (v3/*:: as any*/),
                                      (v4/*:: as any*/),
                                      (v10/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v11/*:: as any*/),
                              (v12/*:: as any*/)
                            ],
                            "storageKey": "verificationPhotos(first:100)"
                          },
                          {
                            "alias": null,
                            "args": (v13/*:: as any*/),
                            "filters": null,
                            "handle": "connection",
                            "key": "useVerificationPhotos_profile_verificationPhotos",
                            "kind": "LinkedHandle",
                            "name": "verificationPhotos"
                          },
                          (v4/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "86f0308b91147a94e55b1fbdf3420327",
    "id": null,
    "metadata": {},
    "name": "PhotoViewDeletePhotoMutation",
    "operationKind": "mutation",
    "text": "mutation PhotoViewDeletePhotoMutation(\n  $input: DeletePhotoInput!\n) {\n  deletePhoto(input: $input) {\n    query {\n      currentUser {\n        profile {\n          photos {\n            totalCount\n          }\n          ...ProfileAvatar_profile\n          ...ProfilePhotosView_profile\n          ...useVerificationPhotos_profile\n          id\n        }\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment ProfileAvatar_profile on Profile {\n  headshot {\n    storageObject {\n      blurhash\n      bucket\n      key\n    }\n    id\n  }\n  name\n}\n\nfragment ProfilePhotosView_profile on Profile {\n  ...useProfilePhotos_profile\n}\n\nfragment useProfilePhotos_profile on Profile {\n  profilePhotos: photos(first: 10, filter: {type: {equalTo: PROFILE}}) {\n    edges {\n      cursor\n      node {\n        description\n        rowId\n        sequence\n        storageObject {\n          blurhash\n          bucket\n          key\n        }\n        id\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment useVerificationPhotos_profile on Profile {\n  user {\n    verificationPhotos(first: 100) {\n      edges {\n        cursor\n        node {\n          createdAt\n          description\n          rowId\n          sequence\n          storageObject {\n            blurhash\n            bucket\n            key\n          }\n          id\n          __typename\n        }\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "e91452d41c5f19253f2d6f7980dad583";

export default node;
